import basic from  './basic'
import service from  './service'
import traffic from  './traffic'
// import module from  './module'
import tha from  './tha'
import engagement from  './engagement'

const es = {
  ...basic,
  ...service,
  ...traffic,
  ...tha,
  ...engagement,
  // ...module,
}

export default es
